import React from "react";
import { render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";
import { CssVarsProvider } from "@mui/joy/styles";
import ViewGridNew from "./ViewGridNew";
import type { ViewDefinition } from "../../types";
import { useViewGridColumns } from "./useViewGridColumns";
import { useRowOperations } from "./useRowOperations";
import { useCanCreateRow } from "../../hooks/useCanCreateRow";
import {
  useBulkDeleteMutation,
  useImportCsvMutation,
} from "../../hooks/useViewDataQuery";
jest.mock("./AuditLogPanel", () => () => null);
jest.mock("./CsvImportDialog", () => () => null);
jest.mock("../pickers/FkSelectionModal", () => () => null);
jest.mock("./ExportButton", () => () => <span />);
jest.mock("./useViewGridColumns");
jest.mock("./useRowOperations");
jest.mock("../../hooks/useCanCreateRow");
jest.mock("../../hooks/useViewDataQuery");
jest.mock("@mui/x-data-grid", () => {
  const actual = jest.requireActual("@mui/x-data-grid");
  return {
    ...actual,
    DataGrid: ({ columns }: { columns: Array<{ field: string }> }) => (
      <div role="grid">
        {columns.map((c) => (
          <span role="columnheader" key={c.field}>
            {c.field}
          </span>
        ))}
      </div>
    ),
  };
});
it("renders the saved canvas column order even when the View supplies another order", () => {
  (useViewGridColumns as jest.Mock).mockReturnValue({
    columns: [
      { field: "name" },
      { field: "email" },
      { field: "role" },
      { field: "_actions" },
    ],
  });
  (useRowOperations as jest.Mock).mockReturnValue({
    rowsWithNew: [],
    newRowData: null,
  });
  (useCanCreateRow as jest.Mock).mockReturnValue({
    data: null,
    isLoading: false,
  });
  (useBulkDeleteMutation as jest.Mock).mockReturnValue({ isPending: false });
  (useImportCsvMutation as jest.Mock).mockReturnValue({ isPending: false });
  render(
    <CssVarsProvider>
      <ViewGridNew
        view={{ id: "view", name: "Staff" } as unknown as ViewDefinition}
        data={null}
        page={0}
        pageSize={10}
        onPageChange={() => {}}
        onPageSizeChange={() => {}}
        visibleColumns={["role", "email", "name"]}
      />
    </CssVarsProvider>,
  );
  expect(screen.getAllByRole("columnheader").map((h) => h.textContent)).toEqual(
    ["role", "email", "name", "_actions"],
  );
});
